import { useApiQuery } from "app/modules/api-client";
import { BasicDurations } from "app/services/DurationService";
import type { DisplayAdvertiserPublisherParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";

import type { AdIntelligenceController } from "../../shared/types/types";

export const usePerformanceOverTimeData = (
    params: DisplayAdvertiserPublisherParams,
    from: string,
    to: string,
    isWindow: boolean,
    controller: AdIntelligenceController = "advertiser",
) => {
    const methodName =
        controller === "advertiser"
            ? "adIntelligenceAdvertiserGraphV2UnifiedList"
            : "adIntelligencePublisherGraphV2UnifiedList";

    return useApiQuery(
        {
            tag: "AdIntelligenceMediaPartners",
            methodName,
        },
        {
            country: params.country,
            key: params.key.split(","),
            from,
            to,
            isWindow,
            ...(isWindow ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {}),
        },
    );
};
